import { SlidersHorizontal } from "@phosphor-icons/react";

import { MobileFiltersDrawer } from "features/filters/components";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import { AUDIENCE_FILTERS } from "../../../../../constants";
import useAudienceFilters from "../../../../../hooks/useAudienceFilters";
import AudienceFilterOptions from "../AudienceFilterOptions";

import type {
  AudienceFacets,
  AudienceFilters as AudienceFiltersType,
} from "../../../../../types";

interface MobileAudienceFiltersProps {
  audienceFacets: AudienceFacets;
  filters: AudienceFiltersType;
  setFilters: (filters: AudienceFiltersType) => void;
  isLoadingFacets: boolean;
  isMiningTargets?: boolean;
}

export default function MobileAudienceFilters({
  audienceFacets,
  filters,
  setFilters,
  isLoadingFacets,
  isMiningTargets = false,
}: MobileAudienceFiltersProps) {
  const { resetAllFilters, setFilterValue } = useAudienceFilters(
    filters,
    setFilters,
  );

  const filterDrawer = (
    <MobileFiltersDrawer
      title="Audience filtering"
      filters={AUDIENCE_FILTERS}
      renderFilter={(filterKey) => (
        <AudienceFilterOptions
          filterKey={filterKey}
          setFilters={setFilters}
          filters={filters}
          audienceFacets={audienceFacets}
          isLoadingFacets={isLoadingFacets}
        />
      )}
      onClear={(type) => {
        if (type === "all") {
          resetAllFilters();
        } else {
          setFilterValue(type, type === "premium" ? undefined : []);
        }
      }}
      getSelectionCount={(filterKey) => {
        if (filterKey === "premium") {
          return filters.premium ? 1 : 0;
        }
        return filters[filterKey].length;
      }}
    />
  );

  if (isMiningTargets) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">
            <Button
              size="lg"
              intent="iconOnly"
              variant="outline-black"
              disabled
            >
              <SlidersHorizontal />
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          You will be able to filter and export your Audience after all targets
          are loaded
        </TooltipContent>
      </Tooltip>
    );
  }

  return filterDrawer;
}
